import { render } from "./formsuppression.vue?vue&type=template&id=61dc68d2&scoped=true"
import script from "./formsuppression.vue?vue&type=script&lang=js"
export * from "./formsuppression.vue?vue&type=script&lang=js"

import "./formsuppression.vue?vue&type=style&index=0&id=61dc68d2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dc68d2"]])

export default __exports__